import CityLink from './CityLink';

export default CityLink;
